import React, { Component } from 'react';
import { connect } from 'react-redux';
import AvaRIEInput from '../fields/input/AvaRIEInput';
import _ from 'lodash';

import Logger, {LOG_LEVELS} from '../../utils/logger';
import { withFullStoryExclude } from '../../utils/fullStoryHelper';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const log = new Logger('DOCUMENT_TOTALS', LOG_LEVELS.DEBUG);

class DocumentTotals extends Component {

  
  render() {
    log.debug('render(): ', this.props);

    if(_.isEmpty(this.props.fieldRefs)) {
      return (
        <div key={this.props.key}></div>
      )
    };
    let invoiceLineIndex = this.props.lineIndex;   
    //Find out the minimum of given total currencies and actual values provided in a invoice line, to map those properly
    let minArrayValueExclVAT = (this.props.currencies.length <= this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueExclVAT.length)
                          ?this.props.currencies:this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueExclVAT;
    let minArrayTaxableBasis = (this.props.currencies.length <= this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueTaxableBasis.length)
                          ?this.props.currencies:this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueTaxableBasis;
    let minArrayValueVAT = (this.props.currencies.length <= this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueVAT.length)
                          ?this.props.currencies:this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueVAT;
   
    return (
      <ReadOnlyWrapper>
        <tbody key={this.props.lineIndex}>
          <tr className={withFullStoryExclude()}>
            <td>
              {
                _.isEmpty(this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueExclVAT) ? 
                (<span></span>) :
                (()=> {
                  return minArrayValueExclVAT.map((_, index) => (
                    <div>
                      <span className="formData float-right">
                        <AvaRIEInput
                          propName={this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueExclVAT[index]}
                          value={this.props.formData[this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueExclVAT[index]]}
                          change={this.props.change}
                        />
                        <span className="ml10">
                          <AvaRIEInput
                              propName={this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceValues[index].Currency}
                              value={this.props.formData[this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceValues[index].Currency]}
                              change={this.props.change}
                          />
                        </span>
                      </span>
                      <span className="clear"></span>
                    </div>
                    ))
                  }
                )()
              }
            </td>
            <td>
              {
                _.isEmpty(this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueTaxableBasis) ? 
                (<span></span>) :
                (()=> {
                  return minArrayTaxableBasis.map((_, index) => (
                    <div>
                      <span className="formData float-right">
                        <AvaRIEInput
                          propName={this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueTaxableBasis[index]}
                          value={this.props.formData[this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueTaxableBasis[index]]}
                          change={this.props.change}
                        />
                        <span className="ml10">
                          <AvaRIEInput
                              propName={this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceValues[index].Currency}
                              value={this.props.formData[this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceValues[index].Currency]}
                              change={this.props.change}
                          />
                        </span>
                      </span>
                      <span className="clear"></span>
                    </div>
                    ))
                  }
                )()
              }
            </td>
            <td>
              {
                _.isEmpty(this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueVAT) ? 
                (<span></span>) :
                (()=> {
                  return minArrayValueVAT.map((_, index) => (
                    <div>
                      <span className="formData float-right">
                        <AvaRIEInput
                          propName={this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueVAT[index]}
                          value={this.props.formData[this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceLines[invoiceLineIndex].ValueVAT[index]]}
                          change={this.props.change}
                        />
                        <span className="ml10">
                          <AvaRIEInput
                              propName={this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceValues[index].Currency}
                              value={this.props.formData[this.props.fieldRefs.ReportingDocument.InvoiceProperties.InvoiceValues[index].Currency]}
                              change={this.props.change}
                          />
                        </span>
                      </span>
                      <span className="clear"></span>
                    </div>
                    ))
                  }
                )()
              }   
            </td>
          </tr>
        </tbody>
      </ReadOnlyWrapper>
    );
  }
}
  

function mapStateToProps(state, props) {
   return {
    // Almost all components will need to use language strings, so add them to the props from the global state
    languages: state.languages,
  };
}


function mapDispatchersToProps(dispatch) {
  return {
    //TODO: Add dispatchers (actions we expect controllers to perform) here.
  }
}
// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchersToProps)(DocumentTotals);
